/* ==========================================================
   WM Header — wm-header.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  class WmHeader extends HTMLElement {
    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._removeListeners();
    }

    _init() {
      this._toggle = this.querySelector('[data-menu-toggle]');
      this._links  = this.querySelectorAll('[data-nav-links] a, .wm-header__logo-link');

      this._boundToggle    = this._handleToggle.bind(this);
      this._boundLinkClick = this._handleLinkClick.bind(this);
      this._boundSectionLoad   = this._handleSectionLoad.bind(this);
      this._boundSectionUnload = this._handleSectionUnload.bind(this);

      if (this._toggle) {
        this._toggle.addEventListener('click', this._boundToggle);
      }

      this._links.forEach(function (link) {
        link.addEventListener('click', this._boundLinkClick);
      }, this);

      document.addEventListener('shopify:section:load',   this._boundSectionLoad);
      document.addEventListener('shopify:section:unload', this._boundSectionUnload);

      this._initCartDrawer();
    }

    _initCartDrawer() {
      if (
        window.theme &&
        window.theme.CartDrawer &&
        window.theme.settings &&
        window.theme.settings.cartType === 'drawer' &&
        document.getElementById('CartDrawer') &&
        !document.body.classList.contains('template-cart') &&
        !window._wmCartDrawer
      ) {
        window._wmCartDrawer = new window.theme.CartDrawer();
      }
    }

    _removeListeners() {
      if (this._toggle) {
        this._toggle.removeEventListener('click', this._boundToggle);
      }

      if (this._links) {
        this._links.forEach(function (link) {
          link.removeEventListener('click', this._boundLinkClick);
        }, this);
      }

      document.removeEventListener('shopify:section:load',   this._boundSectionLoad);
      document.removeEventListener('shopify:section:unload', this._boundSectionUnload);
    }

    _handleToggle() {
      const open = this.classList.toggle('menu-open');
      if (this._toggle) {
        this._toggle.setAttribute('aria-expanded', String(open));
        this._toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }
    }

    _handleLinkClick(event) {
      this.classList.remove('menu-open');
      if (this._toggle) {
        this._toggle.setAttribute('aria-expanded', 'false');
        this._toggle.setAttribute('aria-label', 'Open menu');
      }

      var link = event.currentTarget;
      var href = link.getAttribute('href');
      if (!href) return;

      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      if (!url.hash) return;

      var targetId = url.hash.slice(1);
      if (!targetId) return;

      var isSamePage = url.origin === window.location.origin &&
                       url.pathname === window.location.pathname;
      if (!isSamePage) return;

      var target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      var headerHeight = this.getBoundingClientRect().height;
      var targetTop    = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({ top: targetTop, behavior: 'smooth' });
      history.pushState(null, '', url.hash);
    }

    _handleSectionLoad(event) {
      const section = event.target;
      if (section && section.dataset.sectionType === 'wm-header') {
        this._removeListeners();
        this._init();
      }
    }

    _handleSectionUnload(event) {
      const section = event.target;
      if (section && section.dataset.sectionType === 'wm-header') {
        this._removeListeners();
      }
    }
  }

  if (!customElements.get('wm-header')) {
    customElements.define('wm-header', WmHeader);
  }

})();
